export function AgentCreditsIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M10.8029 2.62687C10.7108 2.25845 10.3798 2 10 2C9.62025 2 9.28923 2.25845 9.19712 2.62687C8.70819 4.5826 7.99558 5.96705 6.98131 6.98131C5.96705 7.99558 4.5826 8.70819 2.62687 9.19712C2.25845 9.28923 2 9.62025 2 10C2 10.3798 2.25845 10.7108 2.62687 10.8029C4.5826 11.2918 5.96705 12.0044 6.98131 13.0187C7.99557 14.033 8.70819 15.4174 9.19712 17.3731C9.28923 17.7415 9.62025 18 10 18C10.3798 18 10.7108 17.7415 10.8029 17.3731C11.2918 15.4174 12.0044 14.033 13.0187 13.0187C14.033 12.0044 15.4174 11.2918 17.3731 10.8029C17.7415 10.7108 18 10.3798 18 10C18 9.62025 17.7415 9.28923 17.3731 9.19712C15.4174 8.70819 14.033 7.99558 13.0187 6.98131C12.0044 5.96705 11.2918 4.5826 10.8029 2.62687Z" fill="url(#paint0_linear_524_2579)" />
      <defs>
        <linearGradient id="paint0_linear_524_2579" x1="11.5172" y1="2" x2="11.5172" y2="18" gradientUnits="userSpaceOnUse">
          <stop offset="0.45" stop-color="#7542F7" />
          <stop offset="1" stop-color="#FFB86B" />
        </linearGradient>
      </defs>
    </svg>
  );
}

AgentCreditsIcon.displayName = 'AgentCreditsIcon';